/**
 * D2C 자사몰 브랜드(예약이 발생한 프론트 앱).
 *
 * 갤럭시렌트카는 제주로와 companyId를 공유하므로(둘 다 7),
 * companyId만으로는 브랜드를 가를 수 없다. 예약 확정 시 이 값을 저장해
 * ERP 애널리틱스에서 브랜드별 유입·매출을 분리한다.
 *
 * `@orcar/common-d2c`의 `AppType`과 값이 1:1로 대응한다.
 * (서버는 common-d2c에 의존할 수 없어 별도 enum으로 둔다.)
 */
export var D2CSourceApp;
(function (D2CSourceApp) {
    D2CSourceApp["RAINBOW"] = "RAINBOW";
    D2CSourceApp["FAMILY"] = "FAMILY";
    D2CSourceApp["JEJURO"] = "JEJURO";
    D2CSourceApp["GALAXY"] = "GALAXY";
})(D2CSourceApp || (D2CSourceApp = {}));
